<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total" :showIndex="true"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import staffTableMixin from "../mixin/table";

export default {
  name: "StaffTempDriver",
  mixins: [tableMixin, staffTableMixin],
  data() {
    return {
      baseUrl: 'shortdriver',
      breadcrumb: [
        { name: "人员管理", path: `/staff/tempDriver` },
        { name: "打短司机管理", path: `/staff/tempDriver` },
      ],
      formCtrl: [
        {
          label: "姓名",
          keyName: "name",
          placeholder: "请填写姓名",
          type: "text",
        },
        /*{
          label: "性别：",
          keyName: "sex",
          placeholder: "请选择性别",
          type: "select",
          options: [
            { label: '男', value: '男' },
            { label: '女', value: '女' },
          ],
        },*/
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/staff/tempDriverDetail?mode=view&id=${id}`
            );
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/staff/tempDriverDetail?mode=edit&id=${id}`
            );
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id);
          },
        },
      ],
      // 重置混入的前置参数，触发自动拉取数据
      baseParams: [],
    };
  },
  methods: {
    addItem() {
      this.$router.push(`/staff/tempDriverDetail`);
    },
  },
};
</script>
